<script lang="ts" setup>

  const props = defineProps<Props>()
  const emit = defineEmits<{
    (e: 'on-favorite-button-click'): void
  }>()

  const { t } = useI18n()

  const router = useRouter()

  type Props = {
    hasFavorite: boolean
  }
  function back() {
    router.back()
  }

</script>
<template>
  <div class="c-action-banner">
    <div class="wrapper">
      <div class="left">
        <div class="action">
          <SvgIcon
            :height="16"
            :width="16"
            icon="arrow-nav"
            @click="back"
          />
        </div>
      </div>
      <div class="right">
        <div
          v-if="props.hasFavorite"
          class="action"
          @click="() => emit('on-favorite-button-click')"
        >
          <SvgIcon
            :height="16"
            :width="18"
            icon="favorite"
          />
          <div class="label">
            {{ t("common.favorite") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>

.c-action-banner {
  position: sticky;
  z-index: 5;
  top: 0;
  display: flex;
  width: 100%;
  height: 0;
  flex-direction: row;
  overflow-y: visible;

  .wrapper {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    height: auto;
    justify-content: space-between;
    padding: 0 0.75em;
    background-image: linear-gradient(to bottom, rgb(0 0 0 / 25%), rgb(0 0 0 / 0%));
    transition: all 0.15s ease-out;

    .right,
    .left {
      display: flex;

      .action {
        display: flex;
        flex-direction: row;
        padding: 1em;
        cursor: pointer;

        .label {
          display: none;
          margin-left: 0.75em;
          color: var(--color-secondary);
          font-family: Open-Sans, sans-serif;
          font-size: 1.125em;
          font-weight: 600;
          opacity: 0.4;
          text-align: center;
        }

        .c-icon {
          color: white;
        }
      }
    }

    .left {
      .action {
        transform: rotate(0.25turn) scale(1.5);

        svg {
          width: 2em;
          height: 2em;
        }
      }
    }
  }

  &.sticky .wrapper {
    background: white;
    box-shadow: var(--box-shadow-1);

    .action .c-icon {
      color: #7f828b;
    }
  }

  &.favorite {
    .wrapper .right .action .c-icon {
      color: var(--color-primary);
      opacity: 1;
    }
  }

  @media screen and (width >= 1024px) {
    height: auto;
    justify-content: center;
    margin-bottom: 2.5em;
    background: white;
    box-shadow: var(--box-shadow-1);

    .wrapper {
      position: relative;
      width: 100%;
      max-width: 1400px;
      flex: 1 0 auto;
      padding: 0 2.5em;
      background-image: none;

      .right,
      .left {
        .action {
          padding: 1.125em 0;

          .c-icon {
            width: 24px;
            height: 24px;
            color: var(--color-secondary);
            opacity: 0.4;
          }

          .label {
            display: inline-block;
          }
        }
      }

      .left {
        .action {
          padding: 1.125em 0;
        }
      }
    }

    &.sticky {
      .wrapper {
        box-shadow: none;
      }
    }
  }
}
</style>
